<template>
  <div class="about-area style-one bg-optional ptb-115">
    <div class="container">
      <div class="row">
        <div class="col-xxl-5 col-lg-6 mb-lg-0 mb-4">
          <div class="about-img-wrap position-relative z-1 overflow-hidden round-20 mb-25">
            <div class="img-container position-absolute top-0 start-0 w-100 h-100">
              <img
                :src="aboutData.mainImage"
                alt="About Us"
                class="w-100 h-100 object-fit-cover round-20"
              />
            </div>
          </div>
          
        </div>

        <div class="col-xxl-6 offset-xxl-1 col-lg-6">
          <div class="about-content">
            <h2 class="section-title style-one fw-semibold ls-n2 text-white mb-40">
              {{ aboutData.title }}
            </h2>
            <div class="row mb-55">
              <div class="col-xxl-8 col-md-7 ps-xxl-4">
                <div v-if="aboutData.content" v-html="aboutData.content" class="text-white mb-35 about-html-content"></div>
                <p v-else class="text-white mb-35">
                  {{ aboutData.description }}
                </p>
                <router-link
                  v-if="aboutData.learnMoreLink"
                  :to="aboutData.learnMoreLink"
                  class="btn style-two d-inline-flex flex-wrap align-items-center transition"
                >
                  <span
                    class="btn-text d-flex flex-column align-items-center justify-content-center transition"
                  >
                    {{ aboutData.learnMoreText }}
                  </span>
                  <span
                    class="btn-icon d-flex flex-column align-items-center justify-content-center transition"
                  >
                    <img :src="rightArrowIcon" alt="Icon" />
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import images
import aboutImageDefault from '@/assets/img/about/about-img-1.jpg'
import rightArrowIcon from '@/assets/img/icons/right-arrow.svg'

export default {
    name: 'AboutUs',
    data() {
        return {
            aboutData: {
                title: 'Pain Clinic in Bangladesh',
                description: 'We combine decades of medical expertise with innovative approaches to deliver exceptional results for our patients.',
                content: null,
                mainImage: aboutImageDefault,
                learnMoreText: 'Learn More',
                learnMoreLink: '/about',
            },
            rightArrowIcon
        }
    },
    async mounted() {
        // Load about data from CMS
        await this.loadAboutData()
        
        // Initialize animations after data is loaded
        this.$nextTick(() => {
            this.initAnimations()
        })
    },
    methods: {
        async loadAboutData() {
            try {
                const response = await this.$api.get('public/content/about')
                if (response.data && response.data.data && response.data.data.length > 0) {
                    // Use first item from the array
                    const aboutContent = response.data.data[0]
                    
                    // Update about data with API response
                    if (aboutContent.title) {
                        this.aboutData.title = aboutContent.title
                    }
                    if (aboutContent.description) {
                        this.aboutData.description = aboutContent.description
                    }
                    if (aboutContent.content) {
                        this.aboutData.content = aboutContent.content
                    }
                    if (aboutContent.featured_image) {
                        this.aboutData.mainImage = aboutContent.featured_image
                    }
                }
            } catch (error) {
                console.error('Failed to load about data:', error)
                // Keep default values
            }
        },
        
        initAnimations() {
            // Check if GSAP is available
            if (typeof window.gsap === 'undefined') {
                console.warn('GSAP not loaded, skipping animations')
                return
            }
            
            const gsap = window.gsap
            const ScrollTrigger = window.ScrollTrigger
            
            if (!ScrollTrigger) {
                console.warn('ScrollTrigger not loaded, skipping animations')
                return
            }
            
            // Parallax image animation
            const containers = document.querySelectorAll('.about-area .img-container')
            containers.forEach((container) => {
                const img = container.querySelector('img')
                if (!img) return
                
                gsap.fromTo(
                    img,
                    { yPercent: -20 },
                    {
                        yPercent: 20,
                        ease: 'none',
                        scrollTrigger: { 
                            trigger: container, 
                            scrub: true 
                        },
                    }
                )
            })
        }
    }
}
</script>

<style scoped>
.about-html-content {
    line-height: 1.8;
}

.about-html-content :deep(p) {
    color: white;
    margin-bottom: 20px;
}

.about-html-content :deep(h1),
.about-html-content :deep(h2),
.about-html-content :deep(h3),
.about-html-content :deep(h4),
.about-html-content :deep(h5),
.about-html-content :deep(h6) {
    color: white;
    margin-bottom: 15px;
    margin-top: 25px;
}

.about-html-content :deep(ul),
.about-html-content :deep(ol) {
    color: white;
    padding-left: 25px;
    margin-bottom: 20px;
}

.about-html-content :deep(li) {
    margin-bottom: 8px;
}

.about-html-content :deep(strong),
.about-html-content :deep(b) {
    font-weight: 600;
}

.about-html-content :deep(a) {
    color: white;
    text-decoration: underline;
    transition: opacity 0.3s ease;
}

.about-html-content :deep(a:hover) {
    opacity: 0.8;
}

.about-img-wrap {
    height: 500px;
}

.img-container {
    z-index: -1;
}

.img-container img {
    transition: transform 0.1s ease-out;
}

@media (max-width: 991px) {
    .about-img-wrap {
        height: 400px;
    }
}

@media (max-width: 767px) {
    .about-img-wrap {
        height: 350px;
    }
}
</style>

